import { render, staticRenderFns } from "./collectionHistory.vue?vue&type=template&id=cd27e0d0&scoped=true"
import script from "./collectionHistory.vue?vue&type=script&lang=js"
export * from "./collectionHistory.vue?vue&type=script&lang=js"
import style0 from "./collectionHistory.vue?vue&type=style&index=0&id=cd27e0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd27e0d0",
  null
  
)

export default component.exports